import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-262" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-263" data-mp="cn7riumnqbzc">
        <div className="text-center mb-16" data-id="element-264" data-mp="cm508llfa7iw">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4" data-id="element-265" data-mp="7qhcmaml9mfi">📚 Le Système 8 en 1 — Détail complet</h2>
          <p className="text-xl text-gold-light" data-id="element-266" data-mp="3g612r0ryqoqc">
            Spanish 1 · Spanish 2 · 40+ semaines de contenu frais · Rien à construire de zéro
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-267" data-mp="3pvkihxkdq2gz">
          {volumes.map((volume, index) => <motion.div key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index % 2 * 0.1
        }} whileHover={{
          y: -5
        }} className={`bg-dark-card rounded-2xl border ${volume.badge ? 'border-gold shadow-[0_0_30px_rgba(212,175,55,0.15)]' : 'border-dark-border'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-268" data-mp="3l3svty4cggw4" data-mpi={index}>
              {volume.badge && <div className="absolute top-4 right-4 bg-gold text-black font-bold text-[10px] tracking-wider py-1 px-3 rounded-full shadow-lg" data-id="element-269" data-mp="2o4eth9pj8hev">
                  ⭐ {volume.badge}
                </div>}
              <div className="flex items-center gap-4 mb-6 pr-24" data-id="element-270" data-mp="1vf7k1foji7eu">
                <span className="text-4xl" aria-hidden="true" data-id="element-271" data-mp="1vhkc4lo0hy5m">
                  {volume.icon}
                </span>
                <div data-id="element-272" data-mp="24gfetnrukq46">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-273" data-mp="24gnvlqr3cfkn">{volume.number}</div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1" data-id="element-274" data-mp="3bsxr8vayhbsp">{volume.title}</h3>
                </div>
              </div>
              <p className="text-white font-medium mb-6 italic border-l-2 border-gold/50 pl-4" data-id="element-275" data-mp="3fxnlygtvokc1">{volume.subtitle}</p>
              <div className="mb-6" data-id="element-276" data-mp="1brq4sbm83o8d">
                <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-277" data-mp="1bqog34cab386">
                  Ce volume résout dans ton enseignement
                </h4>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-278" data-mp="1ksnzu4eoolet">{volume.problem}</p>
              </div>
              <ul className="space-y-3 mb-8 flex-grow" data-id="element-279" data-mp="x2bu906wv0re">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-280" data-mp="t21cyrdo4nx8">
                    <CheckCircle2 size={18} className="text-gold shrink-0 mt-0.5" data-id="element-281" data-mp="16sn04sa5nk0x" />
                    <span className="text-gray-200 text-sm" data-id="element-282" data-mp="16uhko5hila4h">{bullet}</span>
                  </li>)}
              </ul>
              <div className="bg-gold/10 border border-gold/30 rounded-xl p-4 mt-auto" data-id="element-283" data-mp="ebu0csacdz4g">
                <span className="text-gold font-bold block mb-1" data-id="element-284" data-mp="9diqihk1rom8">✅ Résultat :</span>
                <p className="text-white text-sm" data-id="element-285" data-mp="2l0mb3yw2ktgo">{volume.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}